export enum QueryKey {
  GetConfiguration = 'GET_CONFIGURATION',
  IsAuthenticated = 'IS_AUTHENTICATED',
  OnVisibleInViewport = 'ON_VISIBLE_IN_VIEWPORT',
}
